/**
 * Formats a performance date range into a display string.
 * Accepts dates in YYYYMMDD format (as stored in performanceDateRange).
 *
 * @returns formatted string like "(2024-01-01 to 2024-06-30)", or empty string if invalid
 */
const formatPerformanceDateRange = (startDate: string, endDate: string): string => {
  // Validate input: both dates must be exactly 8 characters (YYYYMMDD)
  if (
    !startDate ||
    startDate.length !== 8 ||
    !endDate ||
    endDate.length !== 8 ||
    !/^\d{8}$/.test(startDate) ||
    !/^\d{8}$/.test(endDate)
  ) {
    return "";
  }

  const formattedStart = `${startDate.slice(0, 4)}-${startDate.slice(
    4,
    6
  )}-${startDate.slice(6, 8)}`;
  const formattedEnd = `${endDate.slice(0, 4)}-${endDate.slice(4, 6)}-${endDate.slice(
    6,
    8
  )}`;
  return `(${formattedStart} to ${formattedEnd})`;
};

export default formatPerformanceDateRange;
